import { Logo } from "@/view/components/ui/logo";

export function CreditHeader() {

  return (
    <div className="w-full border-b-2 p-4 border-white pb-2">
      <div className="h-12 max-w-[12rem] mx-auto">
        <Logo className="h-full object-contain" />
      </div>
    </div>
  );
}
